import { Repo } from '@/@types/@repo'
import repoSlug from '@/lib/repoSlug'

export type ProjectTarget = {
  href: string
  external: boolean
}

export default function resolveProjectTarget(project: Repo): ProjectTarget {
  const cardLink = project.links?.find(link => link?.open_on_card)

  if (cardLink?.url) {
    return {
      href: cardLink.url,
      external: true
    }
  }

  const slug = project.slug || repoSlug(project.name)
  return {
    href: `/projects/${slug}`,
    external: false
  }
}
